export const SET_LOADING_TERMINALS = "METRICS_SET_LOADING_TERMINALS"
export const LOAD_TERMINALS = "METRICS_LOAD_TERMINALS"
export const SET_LOADING_METRICS = 'METRICS_SET_LOADING_METRIC_VALUES';
export const LOAD_METRICS = 'METRICS_LOAD_METRIC_VALUES';
export const SET_LOADING_METRIC_DEFINITIONS = 'METRICS_SET_LOADING_METRIC_DEFINITIONS';
export const LOAD_METRIC_DEFINITIONS = 'METRICS_LOAD_METRIC_DEFINITIONS';
export const SET_CREATING_METRIC = 'METRICS_SET_CREATING_METRIC';
export const CREATE_METRIC = 'METRICS_CREATE_METRIC';
export const SET_GETTING_METRIC = 'METRICS_SET_GETTING_METRIC';
export const GET_METRIC = 'METRICS_GET_METRIC';
export const SET_UPDATING_TARGET = 'METRICS_SET_UPDATING_TARGET';
export const UPDATE_TARGET = 'METRICS_UPDATE_TARGET';
export const SET_DELETING_METRIC = 'METRICS_SET_DELETING_METRIC';
export const DELETE_METRIC = 'METRICS_DELETE_METRIC';
export const SET_VALIDATION_ERROR = 'METRICS_SET_VALIDATION_ERROR';
export const CLEAR_VALIDATION_ERROR = 'METRICS_CLEAR_VALIDATION_ERROR';
export const RESET = 'METRICS_RESET';
